// extracted by mini-css-extract-plugin
module.exports = {"text":"Timer_text__xg4Wv"};